/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactNode, useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  InputAdornment,
  TextField,
  CircularProgress, // Import CircularProgress for the loader
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import RangeDatePicker from "../../IotComponent/AppDatePicker/AppDatePicker";
import { FleetDashboardOverviewApi } from "../../../../API/Iot-Api/FleetDashboardOverview/FleetDashobardOverview";
import {
  AllDriverBehaviorReportResponse,
  AllDriverBehaviorReportResponseDownload,
} from "../../../../@Types/DRO/IotApiResponse/FleetOverviewResponse";
import { CSVLink } from "react-csv";

const DriverBehaviorReport = () => {
  const [searchValInput, setSearchValInput] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState<any>();
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
  const [driverBehaviorReport, setDriverBehaviorReport] =
    useState<AllDriverBehaviorReportResponse | null>(null);
  const [driverBehaviorReportDownload, setDriverBehaviorReportDownload] =
    useState<AllDriverBehaviorReportResponseDownload | null>(null);
  const [loading, setLoading] = useState(false); // New state for loading

  const [downloadpage, setDownloadPage] = useState(1);
  const [downloadrowsPerPage, setDownloadRowsPerPage] = useState(50000);
  const [userRole, setUserRole] = useState<string | null>(null);

  useEffect(()=>{
    const role = localStorage.getItem("authority");
    setUserRole(role);
  },[])
  const pageRange = 5;
  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#A4A2A2",
    font: "Rubik",
  };

  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };
  const formatDate = (dateTime: string) => {
    const formattedDateTime = dateTime.replace("T", " "); // Replace "T" with a space
    const date = new Date(formattedDateTime); // Convert to Date object
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`; // Return date and time in YYYY-MM-DD HH:MM:SS format
  };
  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };

  const handleClearSearch = () => {
    setSearchValInput("");
  };

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    setStartDate(dates[0]);
    setEndDate(dates[1]);
  };

  useEffect(() => {
    const fetchDriverBehaviorReport = async () => {
      setLoading(true); // Set loading to true before the API call
      try {
        const data: AllDriverBehaviorReportResponse =
          await FleetDashboardOverviewApi.api.getDriverBehaviorReport(
            searchValInput,
            startDate,
            endDate,
            page + 1,
            rowsPerPage
          );

        setDriverBehaviorReport(data);
        setTotalCount(data.data.total_count);
      } catch (error) {
        console.error("Error fetching fleet summary", error);
      } finally {
        setLoading(false); // Set loading to false after the API call
      }
    };

    fetchDriverBehaviorReport();
  }, [searchValInput, startDate, endDate, page]);

  useEffect(() => {
    const fetchDriverBehaviorReportDownload = async () => {
      setLoading(true); // Set loading to true before the API call
      try {
        const data: AllDriverBehaviorReportResponseDownload =
          await FleetDashboardOverviewApi.api.getDriverBehaviorReportDownload(
            searchValInput,
            startDate,
            endDate,
            downloadpage,
            downloadrowsPerPage
          );

        setDriverBehaviorReportDownload(data);
      } catch (error) {
        console.error("Error fetching fleet summary", error);
      } finally {
        setLoading(false); // Set loading to false after the API call
      }
    };

    fetchDriverBehaviorReportDownload();
  }, [searchValInput, startDate, endDate, downloadpage, downloadrowsPerPage]);
  const driverBehaviorReportButton = [
    { label: "Rider No", key: "cycleId" },
    { label: "Vehicle No", key: "qrcode" },
    { label: "Model", key: "fleet_name" },
    { label: "Hard Acceleration", key: "total_harshA" },
    { label: "Hard Braking", key: "total_harshBreak" },
    { label: "Hard Cornering", key: "total_st" },
    { label: "Driver Risk Category", key: "risk_category" },
  ];

  return (
    <div className="w-full flex bg-white min-h-80 shadow-lg p-3 rounded-xl">
      <div className="w-full">
        <Grid container spacing={5} className="w-full flex justify-between">
          <Grid item md={3}>
            <div className="flex ml-4">
              <h2 className="text-center ml-2 mx-1 mt-2 font-bold text-base text-black pb-2">
                Driver Behavior Report
              </h2>
            </div>
          </Grid>
          <Grid item md={9}>
            <div className="flex mr-4">
              <div className="flex w-full justify-end">
                <div className="flex items-center w-[350px]">
                  <p className="mr-2 font-semibold w-auto">Date Range: </p>
                  <RangeDatePicker
                    onChange={handleDateChange}
                    maxDaysAdd={-1}
                    minDaysSub={92}
                    defaultStartDate={1}
                    defaultEndDate={-1}
                  />
                </div>
                <div className="mr-3">
                  <TextField
                    placeholder="EB Number & User ID"
                    id="outlined-basic"
                    variant="outlined"
                    onChange={(search: any) =>
                      setSearchValInput(search.target.value)
                    }
                    value={searchValInput}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          onClick={handleClearSearch}
                        >
                          <ClearIcon style={{ cursor: "pointer" }} />
                        </InputAdornment>
                      ),
                      style: { height: "40px", borderRadius: "25px" },
                    }}
                  />
                </div>
                {(userRole === "ROLE_FLEET_SUPER_ADMIN" || 
    userRole === "ROLE_ADMIN" || 
    userRole === "ROLE_CO_ADMIN") && ( // Ensure this condition is checked
                <div>
                  <CSVLink
                    data={
                      driverBehaviorReportDownload?.data.rider_behaviour_data ||
                      []
                    }
                    headers={driverBehaviorReportButton}
                    filename={`Driver_Behavior_Report.csv`}
                    style={{ marginRight: "10px" }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#06B681",
                        padding: "8px 20px",
                        color: "#fff",
                        borderRadius: "25px",
                        width: "100%",
                        textTransform: "none",
                        marginLeft: "10px",
                      }}
                    >
                      Download
                    </Button>
                  </CSVLink>
                </div>
                )}
              </div>
            </div>
          </Grid>
        </Grid>
        <hr className="my-4" />
        {loading ? ( // Conditionally render the loader
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="200px"
          >
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 120 }}
                  >
                    User Id
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 150 }}
                  >
                    Vehicle No
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 150 }}
                  >
                    Date
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 110 }}
                  >
                    Model
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 110 }}
                  >
                    Hard Acceleration
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 100 }}
                  >
                    Hard Braking
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 100 }}
                  >
                    Hard Cornering
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 110 }}
                  >
                    Driver Risk Category
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {driverBehaviorReport?.data?.rider_behaviour_data?.map(
                  (item, index) => (
                    <TableRow key={index}>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.userId}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.qrcode}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {formatDate(item.date)}
                      </TableCell>

                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.fleet_name}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.total_harshA}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.total_harshBreak}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.total_st}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.risk_category}
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <div className="pl-2 pt-4 pb-2 pr-16">
          <div
            className="pagination"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 0}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginRight: "6px",
                }}
              >
                {"<"}
              </button>
              {renderPageNumbers()}
              <button
                onClick={() => handlePageChange(page + 1)}
                disabled={page >= pageCount - 1}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginLeft: "6px",
                }}
              >
                {">"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverBehaviorReport;
